// extracted by mini-css-extract-plugin
module.exports = {"input":"AnnulmentComponent_input__20U_r","button":"AnnulmentComponent_button__2jB_b"};